import React, { useEffect } from 'react';
import { Outlet, useParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppButton from '../common/WhatsAppButton';
import { isValidLocale } from '../../lib/utils';

/**
 * Layout principal — Navbar + contenu + Footer + bouton WhatsApp
 * Synchronise la locale de l'URL avec i18next
 */
export default function MainLayout() {
    const { locale } = useParams<{ locale: string }>();
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        /* Rediriger vers /fr si la locale est invalide */
        if (!locale || !isValidLocale(locale)) {
            navigate('/fr', { replace: true });
            return;
        }

        /* Synchroniser i18next avec la locale de l'URL */
        if (i18n.language !== locale) {
            i18n.changeLanguage(locale);
        }

        /* Mettre à jour l'attribut lang du document */
        document.documentElement.lang = locale;
    }, [locale, i18n, navigate]);

    /* Scroll to top lors du changement de page */
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [location.pathname]);

    return (
        <div className="flex flex-col min-h-screen">
            <Navbar />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <WhatsAppButton />
        </div>
    );
}
